import React from 'react';
import { Box, BoxProps, Typography } from '@drone-js/core';
import { MenuState, HeaderMobileProps, RightHeaderItemsProps } from '@agoda/layout';
import { LazyCartIcon } from 'core/utils/lazyCart';

type Props = HeaderMobileProps & RightHeaderItemsProps;

const MenuCms = {
    id: 151885,
    message: 'Menu',
};

const MenuAriaLabel = {
    id: 54745,
    message: 'open menu',
};

export const RenderedItem: React.FC<Props> = (props: Props) => {
    const [focused, setFocused] = React.useState(false);
    const onFocus = () => setFocused(true);
    const onBlur = () => setFocused(false);

    const toggleSideMenu = () => {
        if (props.callbacks.setMenuState) {
            props.callbacks.setMenuState(props.menuState === MenuState.Closed ? MenuState.Open : MenuState.Closed);
        }
    };

    const onKeyDown = (e: { key: string }) => {
        if (e.key === 'Enter') {
            toggleSideMenu();
        }
    };

    const borderProps: BoxProps = React.useMemo(() => {
        return focused ? { border: { width: 'M' }, radius: 'S', borderColor: 'product.primary.strong' } : { style: { marginRight: '2px' } };
    }, [focused]);

    return (
        <>
            <LazyCartIcon onClick={props.callbacks.openCartSummary} />
            <Box key="box1" mx="12" />
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-inconsistent-patterns, @agoda/agoda-a11y/no-incorrect-props, @agoda/agoda-a11y/no-incorrect-drone-box-usage -- @agoda/agoda-a11y/no-inconsistent-patterns[450f6d8b-9d5a-475d-83d6-176f06b983ae], @agoda/agoda-a11y/no-incorrect-props[4831ca55-0b79-4457-a234-760b4d9b0245], @agoda/agoda-a11y/no-incorrect-drone-box-usage[c0127d0c-2c49-4a44-9e2d-d4aadd1a82f5] */}
            <Box
                alignItems="center"
                onClick={toggleSideMenu}
                tabIndex={0}
                aria-label={props.cms(MenuAriaLabel)}
                aria-expanded={props.menuState === MenuState.Open}
                aria-controls="mobile-menu"
                role="button"
                onKeyDown={onKeyDown}
                ref={props.menuButtonRef}
                onFocus={onFocus}
                onBlur={onBlur}
                p="4"
                {...borderProps}
            >
                <Typography tag="span" variant="body-default-strong" textColor="feedback.notice">
                    {props.cms(MenuCms)}
                </Typography>
            </Box>
        </>
    );
};
RenderedItem.displayName = 'RenderedItem';

export const renderRightHeaderItems = (props: Props) => {
    return <RenderedItem {...props} />;
};
